import { createReducer } from "../../common/reduxUtil";

import {
  SET_MAILS,
  APPEND_MAILS,
  SET_TOTAL,
  SET_LOADING,
  SET_LOADING_MORE,
  SET_FILTERS,
  SET_ERROR,
} from "./types";

const initialState = {
  mails: [],
  total: 0,
  loading: false,
  loadingMore: false,
  error: null,
  filters: {
    mailType: "university",
    direction: "all",
    q: "",
    sender: "",
    recipient: "",
    conversationId: "",
    from: "",
    to: "",
  },
};

export default createReducer(initialState, {
  [SET_MAILS]: (state, payload) => {
    return Object.assign({}, state, { mails: payload.mails });
  },
  [APPEND_MAILS]: (state, payload) => {
    return Object.assign({}, state, {
      mails: state.mails.concat(payload.mails),
    });
  },
  [SET_TOTAL]: (state, payload) => {
    return Object.assign({}, state, { total: payload.total });
  },
  [SET_LOADING]: (state, payload) => {
    return Object.assign({}, state, { loading: payload.loading });
  },
  [SET_LOADING_MORE]: (state, payload) => {
    return Object.assign({}, state, { loadingMore: payload.loadingMore });
  },
  [SET_FILTERS]: (state, payload) => {
    return Object.assign({}, state, {
      filters: Object.assign({}, state.filters, payload.filters),
    });
  },
  [SET_ERROR]: (state, payload) => {
    return Object.assign({}, state, { error: payload.error });
  },
});
